import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { isBelowMinZoom } from '../utils/zoomUtils';

export const selectZoom = (state: RootState) => state.map.viewState.zoom;
export const selectLayers = (state: RootState) => state.map.layers;

/**
 * Memoized selector factory — returns true when the given layer is
 * zoom-disabled (current zoom < layer.minZoom).
 */
export const makeSelectIsZoomDisabled = (layerId: string) =>
  createSelector([selectZoom, selectLayers], (zoom, layers) => {
    const layer = layers[layerId];
    if (!layer || !layer.minZoom) return false;
    return isBelowMinZoom(zoom, layer.minZoom);
  });
